import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setBusinessUnit } from "../redux/auth/actions";
import { RiArrowDownSLine } from "react-icons/ri";
import api from "../services/api";

const ALL_ITEM = { _id: "ALL", label: "All Teams", emoji: "\u{1F30D}", color: "#6366f1" };

const BusinessUnitSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [businessUnits, setBusinessUnits] = useState([ALL_ITEM]);
  const dispatch = useDispatch();

  const { businessUnit } = useSelector((state) => state.Auth);

  // Fetch business units from API
  useEffect(() => {
    (async () => {
      try {
        const { data, ok } = await api.get("/business_unit");
        if (ok && data) {
          const units = [ALL_ITEM, ...data.map((bu) => ({ _id: bu._id, label: bu.name, emoji: bu.emoji, color: bu.color }))];
          setBusinessUnits(units);
        }
      } catch (e) {
        console.error("Failed to fetch business units", e);
      }
    })();
  }, []);

  const selected = businessUnits.find((bu) => bu._id === businessUnit._id) || businessUnits[0];

  const handleSelect = (bu) => {
    if (businessUnit._id === bu._id) {
      setIsOpen(false);
      return;
    }

    dispatch(setBusinessUnit({ _id: bu._id, name: bu.label }));
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-all hover:shadow-md border"
        style={{
          backgroundColor: `${selected.color}10`,
          borderColor: `${selected.color}30`,
          color: selected.color,
        }}>
        <span className="text-base">{selected.emoji}</span>
        <span>{selected.label}</span>
        <RiArrowDownSLine className={`w-4 h-4 transition-transform ${isOpen ? "rotate-180" : ""}`} />
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />
          <div className="absolute top-full left-0 mt-1 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50 min-w-[180px]">
            {businessUnits.map((bu) => (
              <button
                key={bu._id}
                onClick={() => handleSelect(bu)}
                className={`w-full flex items-center gap-3 px-3 py-2 text-sm text-left hover:bg-gray-50 transition-colors ${
                  selected._id === bu._id ? "bg-gray-50" : ""
                } ${bu._id === "ALL" ? "border-b border-gray-100" : ""}`}>
                <span className="text-base">{bu.emoji}</span>
                <span className="font-medium" style={{ color: bu.color }}>
                  {bu.label}
                </span>
                {selected._id === bu._id && <span className="ml-auto text-xs px-1.5 py-0.5 rounded bg-gray-200 text-gray-600">Active</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default BusinessUnitSelector;
